import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export default (makeCall: MakeCall) =>
  (conversationID: number, toFavor: boolean) =>
    makeCall<undefined>(
      'PUT',
      `/api/v2/conversation/${conversationID}/${
        toFavor ? 'favorite' : 'unfavorite'
      }`,
    );
